<div class="market-order-details">
  <ion-grid *ngIf="order" no-padding>
    <ion-row>
      <ion-col
        text-center=""
        size="12"
        no-padding-bottom=""
        no-padding-left
        no-padding-right
        class="order-status"
      >
        <ion-text font-bold color="primary">
          •
          {{
            (order?.status === "ORDER_COMPLETED" && order?.payment
              ? order?.payment?.statusTitle
              : order?.displayStatusTitle
            ) | uppercase
          }}
          •
        </ion-text>
      </ion-col>
      <!--<ion-col size="12" text-center>
                <ion-button color="medium" size="small" >Invoices & other documents</ion-button>
            </ion-col>-->
      <ion-col
        text-center=""
        size="12"
        no-padding-top=""
        no-padding-left
        no-padding-right
        class="order-status-subtitle"
      >
        <ion-text color="medium">
          <span *ngIf="order?.status === 'CREATED'">
            <span *ngIf="order?.saleOrder">Order allocated to buyer</span>
            <span *ngIf="!order?.saleOrder">Order allocated to seller</span>
          </span>
          <span *ngIf="order?.status === 'PICKUP_SCHEDULED'">
            Order dispatched to buyer
          </span>
          <span *ngIf="order?.status === 'SETTLED'">Payment Completed.</span>
          <span *ngIf="order?.status === 'MATERIAL_RECEIVED'">
            Order delivered to buyer location
          </span>
        </ion-text>
      </ion-col>
    </ion-row>

    <!--<ion-row *ngIf="order?.status === 'CREATED'">
            <ion-col size="12" text-center="" no-padding-bottom="" no-padding-left no-padding-right
                     class="download-invoice">
                <ion-button color="medium" size="small" (click)="downloadInvoiceClicked()" font-regular="">
                    <ion-icon size="small" name="download"></ion-icon>
                    DOWNLOAD INVOICE
                </ion-button>
            </ion-col>
            <ion-col class="download-invoice-subtitle" size="12" *ngIf="order?.status === 'CREATED'" text-center=""
                     no-padding-top="" no-padding-left no-padding-right>
                <ion-text color="medium">Download creation invoice</ion-text>
            </ion-col>
        </ion-row>-->
    <!-- <ion-row *ngIf="order?.status === 'PICKUP_SCHEDULED'">
            <ion-col size="12" text-center="" no-padding-left no-padding-right no-padding-bottom=""
                     class="download-invoice">
                <ion-button (click)="openFileManager(orderSellerWeighBridgeDocs, 'SELLER_WEIGH_BRIDGE')" color="medium"
                            size="small" font-regular>
                    <ion-icon size="small" name="document"></ion-icon>
                    SELLER WEIGHBRIDGE
                </ion-button>
            </ion-col>
            <ion-col class="download-invoice-subtitle" size="12" *ngIf="order?.status === 'CREATED'" text-center=""
                     no-padding-left no-padding-right no-padding-top="">
                <ion-text color="medium"> Before & after loading both bills required</ion-text>
            </ion-col>
        </ion-row>-->
    <!-- <ion-row *ngIf="containsInStatusLog('MATERIAL_RECEIVED')" class="download-buttons">
            <ion-col text-center [size]="containsInStatusLog('ORDER_COMPLETED') ? 4: 6"
                     class="download-invoice">
                <ion-button (click)="openFileManager(orderSellerWeighBridgeDocs, 'SELLER_WEIGH_BRIDGE')" color="medium"
                            font-regular>
                    <ion-icon size="small" name="eye"></ion-icon>
                    SELLER WEIGHBRIDGE
                </ion-button>
            </ion-col>

            <ion-col text-center [size]="containsInStatusLog('ORDER_COMPLETED') ? 4 : 6" no-padding-left
                     class="download-invoice">
                <ion-button (click)="openFileManager(orderBuyerWeighBridgeDocs, 'BUYER_WEIGH_BRIDGE')" color="medium"
                            font-regular>
                    <ion-icon size="small" name="eye"></ion-icon>
                    BUYER WEIGHBRIDGE
                </ion-button>
            </ion-col>

            <ion-col size="4" *ngIf="containsInStatusLog('ORDER_COMPLETED')"  no-padding-left
                     text-center class="download-invoice">
                <ion-button (click)="openFileManager(orderLabReportDocs, 'LAB_REPORT')" color="medium" font-regular>
                    <ion-icon size="small" name="eye"></ion-icon>
                    LAB REPORT
                </ion-button>
            </ion-col>

        </ion-row>-->

    <ion-row>
      <!-- item info -->
      <ion-col size="12" no-padding-left no-padding-right>
        <ion-card no-margin no-box-shadow class="item-card">
          <ion-row *ngFor="let orderItem of order?.orderItems">
            <ion-col
              size="6"
              text-left=""
              class="item-name"
              no-padding-left=""
              no-padding-bottom=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold>{{
                orderItem?.item?.name
              }}</ion-text>
              <br />
              <ion-text color="medium" font-regular="">ITEM</ion-text>
            </ion-col>
            <ion-col
              size="6"
              text-right=""
              class="item-rate"
              no-padding-right=""
              no-padding-bottom=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold>{{
                orderItem?.itemPrice | currency: "INR"
              }}</ion-text>
              <br />
              <ion-text color="medium" font-regular=""
                >Price per {{ orderItem?.item?.unitType }}</ion-text
              >
            </ion-col>
            <ion-col
              size="12"
              padding-top=""
              d-flex
              text-right=""
              class="view-quality-req"
              no-padding-left=""
              no-padding-right=""
              no-padding-bottom=""
            >
              <ion-icon size="small" color="primary" name="document"></ion-icon>
              <ion-text
                color="primary"
                font-bold=""
                (click)="viewQualityRequirementClicked(orderItem?.item)"
                >View Quality Requirement
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- item info end -->

      <!-- quantity and amount info -->
      <ion-col size="12" no-padding-left no-padding-right>
        <ion-card no-margin no-box-shadow class="card-expandable qty-amt-card">
          <ion-row (click)="qtyAmtCard = !qtyAmtCard">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold="">QUANTITY & AMOUNT</ion-text>
              <ion-icon
                float-end=""
                [color]="qtyAmtCard ? 'medium' : 'light'"
                [name]="
                  qtyAmtCard ? 'arrow-dropup-circle' : 'arrow-dropdown-circle'
                "
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="qtyAmtCard" text-center="" padding-top="">
            <ion-col size="12" no-padding>
              <ion-row text-left="">
                <ion-col size="4" class="status" padding-start="">
                  <ion-text color="dark" font-bold="">Allocated</ion-text>
                </ion-col>
                <ion-col class="amt" size="4" padding-start="">
                  <ion-text color="medium" font-regular="">{{
                    order?.orderItems[0]?.formattedQty
                  }}</ion-text>
                </ion-col>
                <ion-col size="4" padding-start="" class="price">
                  <ion-text color="dark" font-bold="">{{
                    order?.orderItems[0]?.initialAmount | currency: "INR"
                  }}</ion-text>
                </ion-col>
              </ion-row>
            </ion-col>
            <ion-col
              size="12"
              no-padding
              *ngIf="
                order?.orderItems[0]?.formattedVerifyQty &&
                containsInStatusLog('PICKUP_SCHEDULED')
              "
            >
              <ion-row text-left="">
                <ion-col size="4" padding-start="" class="status">
                  <ion-text color="dark" font-bold="">Dispatched</ion-text>
                </ion-col>
                <ion-col class="amt" size="4" padding-start="">
                  <ion-text color="medium" font-regular="">{{
                    order?.orderItems[0]?.formattedVerifyQty
                  }}</ion-text>
                </ion-col>
                <ion-col size="4" padding-start="" class="price">
                  <ion-text color="dark" font-bold="">
                    {{ order?.orderItems[0]?.verifiedAmount | currency: "INR" }}
                  </ion-text>
                </ion-col>
              </ion-row>
            </ion-col>
            <ion-col
              size="12"
              no-padding
              *ngIf="
                order?.orderItems[0]?.formattedReceivedQty &&
                containsInStatusLog('ORDER_COMPLETED')
              "
            >
              <ion-row text-left="">
                <ion-col size="4" padding-start="" class="status">
                  <ion-text color="primary" font-bold="">Final</ion-text>
                </ion-col>
                <ion-col size="4" class="amt" padding-start="">
                  <ion-text color="primary" font-regular="">{{
                    order?.orderItems[0]?.formattedReceivedQty
                  }}</ion-text>
                </ion-col>
                <ion-col size="4" padding-start="" class="price">
                  <ion-text color="primary" font-bold="">{{
                    order?.orderItems[0]?.receivedAmount | currency: "INR"
                  }}</ion-text>
                </ion-col>
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- quantity and amount info end -->

      <!-- logistic form open -->
      <ion-col
        size="12"
        no-padding-left
        no-padding-right
        *ngIf="
          order?.saleOrder &&
          !orderLogisticsDetails &&
          !containsInStatusLog(orderStatuses.MATERIAL_PICKED)
        "
      >
        <ion-card
          no-margin
          no-box-shadow
          class="card-expandable transport-details-card"
        >
          <ion-row (click)="openTransportationDetailsModal()">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold=""
                >TRANSPORTER AND DRIVER DETAILS</ion-text
              >
              <ion-icon
                float-end=""
                color="light"
                name="arrow-dropright-circle"
              ></ion-icon>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- logistic form open end -->

      <!-- transporter and vehicle details -->
      <ion-col size="12" no-padding *ngIf="orderLogisticsDetails">
        <rcyl-transporter-vehicle-details
          [enableEdit]="order?.saleOrder"
          [orderStatusLogs]="orderStatusLogs"
          (openTransportationDetailsModal)="openTransportationDetailsModal()"
          [orderLogisticsDetails]="orderLogisticsDetails"
        ></rcyl-transporter-vehicle-details>
      </ion-col>
      <!-- transporter and vehicle details end -->

      <!-- driver information -->
      <ion-col size="12" no-padding *ngIf="orderLogisticsDetails">
        <rcyl-driver-details
          [enableEdit]="order?.saleOrder"
          [orderLogisticsDetails]="orderLogisticsDetails"
          [orderStatusLogs]="orderStatusLogs"
          (openTransportationDetailsModal)="openTransportationDetailsModal()"
        ></rcyl-driver-details>
      </ion-col>

      <!-- driver information -->

      <!-- transportation details -->
      <ion-col size="12" no-padding-left no-padding-right>
        <ion-card
          no-margin
          no-box-shadow
          class="card-expandable transport-details-card"
        >
          <ion-row (click)="transDetailsCard = !transDetailsCard">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold=""
                >TRANSPORTATION DETAILS</ion-text
              >
              <ion-icon
                float-end=""
                [color]="transDetailsCard ? 'medium' : 'light'"
                [name]="
                  transDetailsCard
                    ? 'arrow-dropup-circle'
                    : 'arrow-dropdown-circle'
                "
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="transDetailsCard">
            <ion-col
              size="12"
              no-padding-left=""
              no-padding-right=""
              no-padding-bottom=""
              padding-top=""
            >
              <ion-row>
                <ion-col size="10" text-left="">
                  <ion-text color="medium" class="to-from-location" font-bold
                    >Dispatched From
                  </ion-text>
                  <br />
                  <ion-text color="dark" class="location-name">{{
                    order?.fromLocation?.name | uppercase
                  }}</ion-text>
                  <br />
                  <ion-text color="dark" font-bold class="street"
                    >{{
                      order?.fromLocation?.addressInfo?.landmark
                        ? order?.fromLocation?.addressInfo?.landmark + ","
                        : ""
                    }}
                    {{ order?.fromLocation?.addressInfo?.street }}</ion-text
                  >
                </ion-col>
                <!--<ion-col size="2" *ngIf="order?.status === 'CREATED'">
                                    <ion-button float-end="" color="medium" size="small" fill="outline">
                                        EDIT
                                    </ion-button>
                                </ion-col>-->
              </ion-row>
            </ion-col>
            <ion-col
              size="12"
              no-padding=""
              *ngIf="order?.status === 'SETTLED'"
            >
              <ion-row>
                <ion-col size="10" text-left="">
                  <ion-label color="medium" class="to-from-location" font-bold
                    >Delivered At
                  </ion-label>
                  <br />
                  <ion-text color="dark" class="location-name">{{
                    order?.toLocation?.name | uppercase
                  }}</ion-text>
                  <br />
                  <ion-text color="dark" font-bold class="street"
                    >{{
                      order?.toLocation?.addressInfo?.landmark
                        ? order?.toLocation?.addressInfo?.landmark + ","
                        : ""
                    }}
                    {{ order?.toLocation?.addressInfo?.street }}</ion-text
                  >
                </ion-col>
                <!--<ion-col size="2" *ngIf="order?.status === 'CREATED'">
                                    <ion-button float-end="" color="light" size="small" fill="outline">EDIT</ion-button>
                                </ion-col>-->
              </ion-row>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- transportation details end-->

      <!-- buyer details -->
      <ion-col
        size="12"
        *ngIf="order?.saleOrder"
        no-padding-left
        no-padding-right
      >
        <ion-card
          no-margin
          no-box-shadow
          class="card-expandable buyer-seller-details-card"
        >
          <ion-row (click)="buyerSellerDetailsCard = !buyerSellerDetailsCard">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold="">BUYER DETAILS</ion-text>
              <ion-icon
                float-end=""
                [color]="buyerSellerDetailsCard ? 'medium' : 'light'"
                [name]="
                  buyerSellerDetailsCard
                    ? 'arrow-dropup-circle'
                    : 'arrow-dropdown-circle'
                "
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="buyerSellerDetailsCard" padding-top="">
            <ion-col size="12" no-padding-top="">
              <ion-text color="medium" class="info-label" font-bold=""
                >Buyer Name</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">{{
                order?.buyer?.name
              }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-text color="medium" class="info-label"
                >Contact Number</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">{{
                order?.buyer?.mobile
              }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-text color="medium" class="info-label"
                >Buyer Address</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">
                {{
                  order?.buyer?.address?.landmark
                    ? order?.buyer?.address?.landmark + ", "
                    : ""
                }}
                {{ order?.buyer?.address?.street }}
              </ion-text>
            </ion-col>
            <ion-col size="12" *ngIf="orderAdditionalComment">
              <ion-text color="medium" class="info-label"
                >Additional Comments</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">
                {{ orderAdditionalComment }}
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- buyer details end -->

      <!-- seller details -->
      <ion-col
        size="12"
        *ngIf="!order?.saleOrder"
        no-padding-left
        no-padding-right
      >
        <ion-card
          no-margin
          no-box-shadow
          class="card-expandable buyer-seller-details-card"
        >
          <ion-row (click)="buyerSellerDetailsCard = !buyerSellerDetailsCard">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold="">SELLER DETAILS</ion-text>
              <ion-icon
                float-end=""
                [color]="buyerSellerDetailsCard ? 'medium' : 'light'"
                [name]="
                  buyerSellerDetailsCard
                    ? 'arrow-dropup-circle'
                    : 'arrow-dropdown-circle'
                "
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="buyerSellerDetailsCard" padding-top="">
            <ion-col size="12" no-padding-top="">
              <ion-text color="medium" class="info-label" font-bold=""
                >Seller Name</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">{{
                order?.seller?.name
              }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-text color="medium" class="info-label" font-bold=""
                >Contact Number</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">{{
                order?.seller?.mobile
              }}</ion-text>
            </ion-col>
            <ion-col size="12">
              <ion-text color="medium" class="info-label" font-bold=""
                >Seller Address</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">
                {{
                  order?.seller?.address?.landmark
                    ? order?.seller?.address?.landmark + ", "
                    : ""
                }}
                {{ order?.seller?.address?.street }}
              </ion-text>
            </ion-col>
            <ion-col size="12" *ngIf="orderAdditionalComment">
              <ion-text color="medium" class="info-label" font-bold=""
                >Additional Comments</ion-text
              >
              <br />
              <ion-text color="dark" class="info" font-bold="">
                {{ orderAdditionalComment }}
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- seller details end -->

      <!-- view upload item image -->
      <ion-col
        size="12"
        no-padding-left
        no-padding-right
        *ngIf="
          order?.saleOrder ||
          (!order?.saleOrder &&
            orderDocuments[orderDocumentTypes.ITEM_IMAGE]?.documents.length > 0)
        "
      >
        <ion-card
          no-margin
          no-box-shadow
          class="card-expandable upload-img-card"
        >
          <ion-row (click)="uploadImgCard = !uploadImgCard">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold="" *ngIf="order?.saleOrder"
                >UPLOAD IMAGE
              </ion-text>
              <ion-text color="dark" font-bold="" *ngIf="!order?.saleOrder"
                >VIEW IMAGE
              </ion-text>
              <ion-icon
                float-end=""
                [color]="uploadImgCard ? 'medium' : 'light'"
                [name]="
                  uploadImgCard
                    ? 'arrow-dropup-circle'
                    : 'arrow-dropdown-circle'
                "
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="uploadImgCard">
            <ion-col no-padding="" size="12">
              <rcyl-img-list
                [docList]="orderDocuments.ITEM_IMAGE.documents"
                (onCapture)="orderImgCapture()"
                [docType]="orderDocumentTypes.ITEM_IMAGE"
                [downloadDocumentCallback]="downloadFile"
                [deleteDocumentCallback]="confirmAndDeleteDocument"
                [showDelete]="order?.saleOrder"
                [showCapture]="order?.saleOrder"
              ></rcyl-img-list>
            </ion-col>
            <ion-col
              size="12"
              text-center=""
              class="desc-text"
              *ngIf="order?.saleOrder"
            >
              <ion-text color="dark">
                Images required for before loading, while loading and after
                loading the material. Also, when the vehicle leaves the pickup
                location. Please make sure that vehicle number is visible in
                atleast one of the images that you upload
              </ion-text>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- view upload item image end-->

      <!-- document manager -->
      <ion-col size="12" no-padding-left no-padding-right>
        <ion-card no-margin no-box-shadow class="card-expandable qty-amt-card">
          <ion-row (click)="openDocumentManager()">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold=""
                >INVOICES & DOCUMENTS</ion-text
              >
              <ion-icon
                color="light"
                float-end=""
                name="arrow-dropright-circle"
              ></ion-icon>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- document manager end -->

      <!-- order status flow -->
      <ion-col no-padding-left no-padding-right size="12">
        <ion-card
          no-margin
          no-box-shadow
          class="card-expandable order-status-flow-card"
        >
          <ion-row (click)="orderStatusFlow = !orderStatusFlow">
            <ion-col
              size="12"
              class="card-title"
              no-padding-left=""
              no-padding-right=""
              no-padding-top=""
            >
              <ion-text color="dark" font-bold="">ORDER STATUS FLOW</ion-text>
              <ion-icon
                float-end=""
                [color]="orderStatusFlow ? 'medium' : 'light'"
                [name]="
                  orderStatusFlow
                    ? 'arrow-dropup-circle'
                    : 'arrow-dropdown-circle'
                "
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row *ngIf="orderStatusFlow">
            <ion-col size="12" no-padding-top="">
              <div class="timeline-wrapper">
                <ul class="step-progress">
                  <li
                    class="step-progress-item"
                    [ngClass]="{ 'is-done': containsInStatusLog('CREATED') }"
                  >
                    <ion-text color="dark" font-bold="">Created</ion-text>
                    <br />
                    <ion-text color="medium">
                      {{ order?.createdDate | date: "d MMMM, y" }}
                      at {{ order?.createdDate | date: "HH:MM a" }}
                    </ion-text>
                  </li>
                  <li
                    class="step-progress-item step-danger"
                    *ngIf="
                      order?.status === 'CANCELLED' ||
                      order?.status === 'REJECTED'
                    "
                    [ngClass]="{
                      'is-done':
                        containsInStatusLog('CANCELLED') ||
                        containsInStatusLog('REJECTED')
                    }"
                  >
                    <ion-text color="dark" font-bold="">Cancelled</ion-text>
                    <br />
                    <ion-text color="medium">
                      Your order is cancelled.
                    </ion-text>
                  </li>
                  <li
                    class="step-progress-item"
                    [ngClass]="{
                      'is-done': containsInStatusLog('PICKUP_SCHEDULED')
                    }"
                  >
                    <ion-text color="dark" font-bold="">Dispatched</ion-text>
                    <br />
                    <ion-text
                      color="medium"
                      *ngIf="!containsInStatusLog('PICKUP_SCHEDULED')"
                    >
                      Your order is yet to dispatch.
                    </ion-text>
                    <ion-text
                      color="medium"
                      *ngIf="containsInStatusLog('PICKUP_SCHEDULED')"
                    >
                      Your order is dispatched.
                    </ion-text>
                  </li>
                  <li
                    class="step-progress-item"
                    [ngClass]="{
                      'is-done': containsInStatusLog('MATERIAL_RECEIVED')
                    }"
                  >
                    <ion-text color="dark" font-bold="">{{
                      order?.saleOrder ? "Delivered" : "Received"
                    }}</ion-text>
                    <br />
                    <ion-text
                      color="medium"
                      *ngIf="!containsInStatusLog('MATERIAL_RECEIVED')"
                    >
                      Your order is yet to be
                      {{ order?.saleOrder ? "delivered" : "received" }}.
                    </ion-text>
                    <ion-text
                      color="medium"
                      *ngIf="containsInStatusLog('MATERIAL_RECEIVED')"
                    >
                      Your order is
                      {{ order?.saleOrder ? "delivered" : "received" }}.
                    </ion-text>
                  </li>
                  <li
                    class="step-progress-item"
                    [ngClass]="{
                      'is-done':
                        containsInStatusLog('COMPLETED') ||
                        containsInStatusLog('ORDER_COMPLETED')
                    }"
                  >
                    <ion-text color="dark" font-bold="">QC Done</ion-text>
                    <br />
                    <ion-text color="medium">Material got QC'ed.</ion-text>
                  </li>
                  <li
                    class="step-progress-item"
                    [ngClass]="{ 'is-done': containsInStatusLog('COMPLETED') }"
                  >
                    <ion-text color="dark" font-bold="">Completed</ion-text>
                    <br />
                    <ion-text color="medium"
                      >The transaction has been completed.</ion-text
                    >
                  </li>
                </ul>
              </div>
            </ion-col>
          </ion-row>
        </ion-card>
      </ion-col>
      <!-- order status flow end -->

      <!-- Bottom buttons -->
      <ion-col
        no-padding-left
        *ngIf="order?.status === 'CREATED'"
        size="12"
        no-padding-right=""
        text-center
        align-items-center=""
      >
        <div class="two-bottom-btn" text-center="">
          <ion-button
            *ngIf="order?.saleOrder"
            class="bottom-btn"
            (click)="markForDispatch()"
            size="small"
            color="medium"
          >
            <ion-icon name="time"></ion-icon>
            Mark for Dispatch
          </ion-button>
          <ion-button
            class="bottom-btn"
            (click)="openCancelOrderDialog()"
            size="small"
            color="medium"
          >
            <ion-icon name="close" mode="ios"></ion-icon>
            Cancel Order
          </ion-button>
        </div>
      </ion-col>
      <ion-col
        no-padding-left
        *ngIf="order?.status === 'PICKUP_SCHEDULED' && !order?.saleOrder"
        size="12"
        no-padding-right=""
        text-center
      >
        <ion-button
          class="bottom-btn"
          (click)="promptFormMarkAsReceived(order?.toLocation?.id, order?.id)"
          size="small"
          color="medium"
        >
          <ion-icon name="time"></ion-icon>
          &nbsp;Mark as Received
        </ion-button>
      </ion-col>
      <ion-col
        *ngIf="order?.status === 'MATERIAL_RECEIVED' && !order?.saleOrder"
        no-padding-left
        size="12"
        no-padding-right=""
        text-center
      >
        <ion-button
          (click)="beginQc()"
          class="bottom-btn"
          size="small"
          color="medium"
        >
          <ion-icon name="time"></ion-icon>
          &nbsp;Begin Quality Check
        </ion-button>
      </ion-col>
      <!-- Bottom buttons end -->
    </ion-row>
  </ion-grid>
</div>
